import { memo } from "react";
import SettingsCard from "../common/settings-card";
import GreetingInput from "./greeting-input";

const GreetingSettings = () => {
  return (
    <SettingsCard title="Greeting Messages">
      <GreetingInput />
    </SettingsCard>
  );
};

export default memo(GreetingSettings);
